import type { InAppNotificationItem } from "@/services/APIs/NotificationService";

/** In-app notifications with these `extra.app` values belong in PTS. */
export const PTS_IN_APP_NOTIFICATION_APP = "pts";

/** Production tickets use `servicedesk`; PTS module alerts use `pts`. */
const PTS_IN_APP_NOTIFICATION_APPS = new Set(["pts", "servicedesk"]);

export const isPtsInAppNotification = (
  item: Pick<InAppNotificationItem, "extra">
): boolean => {
  const app = item?.extra?.app;
  if (app === undefined || app === "" || app === null) {
    return true;
  }
  return PTS_IN_APP_NOTIFICATION_APPS.has(String(app).toLowerCase());
};

export const filterPtsInAppNotifications = <
  T extends Pick<InAppNotificationItem, "extra">,
>(
  items: T[] | undefined | null
): T[] => (items ?? []).filter(isPtsInAppNotification);
